import { render, staticRenderFns } from "./activities.vue?vue&type=template&id=21c1851e&scoped=true&"
import script from "./activities.vue?vue&type=script&lang=js&"
export * from "./activities.vue?vue&type=script&lang=js&"
import style0 from "./activities.css?vue&type=style&index=0&id=21c1851e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c1851e",
  null
  
)

export default component.exports